import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import handleHospital from "@/services/modules/hospital";
import { isArray } from 'lodash';
import { convertToTitleCase } from '@/services/utils/global';

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const ipdStaticAdmission = () => {
    const { calculateAge } = handleHospital();

    const exportToStaticPDF = (company, admissionInfo) => {
        const phcGeneral = admissionInfo.phc_general || {};
        const patient = admissionInfo.patient || {};

        var doc = {
            pageSize: 'A4',
            pageMargins: [ 25, 20, 25, 40 ],
            content: getStaticContent(company, admissionInfo, phcGeneral, patient),
            defaultStyle: {
                color: 'black',
                fontSize: 9,
                font: 'SulaimanLipi'
            },
            styles: {
                tableHeader: {
                    bold: true,
                    fontSize: 10,
                    color: 'black',
                    fillColor: '#f2f2f2'
                },
                sectionHeader: {
                    bold: true,
                    fontSize: 11,
                    margin: [0, 5, 0, 5],
                    fillColor: '#e6e6e6'
                }
            },
            info: {
                title: 'Admission Form'
            }
        }

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getStaticContent = (company, admissionInfo, phcGeneral, patient) => {
        const notes = admissionInfo.notes || [];
        const findNote = (type) => {
            const note = notes.find(n => n.type === type);
            if (!note || !note.note) return '';
            
            let noteData = note.note;
            
            if (type !== 'investigation_history') {
                return isArray(noteData) ? noteData.join(', ') : noteData;
            }

            if (typeof noteData === 'string') {
                try {
                    noteData = JSON.parse(noteData);
                } catch (e) {
                    noteData = [];
                }
            }

            const formattedNotes = noteData.map(n => {
                return n.name + (n.result ? ` - ( ${n.result} )` : '')
            })

            return formattedNotes.join(', ');
        };

        const admissionDataParts = admissionInfo.formattedAdmissionData ? admissionInfo.formattedAdmissionData.split(' ') : [];
        const admissionDate = admissionDataParts[0] || '';
        const admissionTime = admissionDataParts.length > 1 ? admissionDataParts.slice(1).join(' ') : '';

        return [
            {
                image: company.cover_photo64,
                width: 550,
                alignment: 'center',
            },
            {
                text: 'ADMISSION FORM',
                alignment: 'center',
                bold: true,
                fontSize: 18,
                margin: [0, 10, 0, 10],
                background: '#cccccc'
            },
            {
                table: {
                    widths: ['15%', '20%', '10%', '15%', '10%', '10%', '10%', '10%'],
                    body: [
                        [
                            { text: 'Reg. ID :', bold: true },
                            { text: admissionInfo.admission_no || '' },
                            { text: 'Unit :', bold: true },
                            { text: admissionInfo.department ? admissionInfo.department.name : '' },
                            { text: 'Bed No:', bold: true },
                            { text: admissionInfo.service_resource ? admissionInfo.service_resource.name : '' },
                            { text: 'Sex:', bold: true },
                            { text: convertToTitleCase(patient.gender) }
                        ],
                        [
                            { text: 'Name of the Patient:', bold: true },
                            { text: patient.full_name || '', colSpan: 3 },
                            {},
                            {},
                            { text: 'Religion:', bold: true },
                            { text: convertToTitleCase(patient.religion) },
                            { text: 'Age:', bold: true },
                            { text: calculateAge(patient.birthday) || '' }
                        ],
                        [
                            { text: "Patient's Guardian Name:", bold: true },
                            { text: patient.guardian_name || '', colSpan: 3 },
                            {},
                            {},
                            { text: 'Relationship with the Patient :', bold: true, colSpan: 2 },
                            {},
                            { text: convertToTitleCase(patient.guardian_relationship), colSpan: 2 },
                            {}
                        ],
                        [
                            { text: "Patient's NID No. :", bold: true },
                            { text: patient.nid || '', colSpan: 3 },
                            {},
                            {},
                            { text: "Mob. No.", bold: true },
                            { text: patient.mobile_no || '' },
                            { text: "Emergency Contact:", bold: true },
                            { text: patient.guardian_mobile_no || '' }
                        ],
                        [
                            { 
                                text: [
                                    { text: "Patient's Address: ", bold: true },
                                    { text: "Permanent: " },
                                    { text: "[   ]", fontSize: 12 },
                                    { text: " Present: " },
                                    { text: "[   ]", fontSize: 12 },
                                    { text: " Guardian :(Optional) " },
                                    { text: "[   ]", fontSize: 12 }
                                ], 
                                colSpan: 8 
                            },
                            {}, {}, {}, {}, {}, {}, {}
                        ],
                        [
                            { text: 'Flat/Apartment No. : .................................. House No.: .................................................... Road No.: .................................................', colSpan: 8, margin: [0, 5] },
                            {}, {}, {}, {}, {}, {}, {}
                        ],
                        [
                            { text: 'Village/Area: .......................................................................................................... Post Office: .................................................', colSpan: 8, margin: [0, 5] },
                            {}, {}, {}, {}, {}, {}, {}
                        ],
                        [
                            { text: 'Thana/Upazila: ........................................................................................................ District: ...................................................', colSpan: 8, margin: [0, 5] },
                            {}, {}, {}, {}, {}, {}, {}
                        ],
                        [
                            { text: 'Admission Date:', bold: true },
                            { text: admissionDate, colSpan: 2 },
                            {},
                            { text: 'Admission Time:', bold: true },
                            { text: admissionTime, colSpan: 4 },
                            {}, {}, {}
                        ],
                        [
                            { text: 'Discharge Date:', bold: true },
                            { text: '', colSpan: 2 },
                            {},
                            { text: 'Discharge Time:', bold: true },
                            { text: '', colSpan: 4 },
                            {}, {}, {}
                        ],
                        [
                            { text: 'Admitted Under: (Consultant/Surgeon Name):', bold: true, colSpan: 4, background: '#f2f2f2' },
                            {}, {}, {},
                            { text: 'Department:', bold: true, colSpan: 4, background: '#f2f2f2' },
                            {}, {}, {}
                        ],
                        [
                            { text: 'A. ' + (admissionInfo.consultant ? admissionInfo.consultant.name : ''), colSpan: 4 },
                            {}, {}, {},
                            { text: admissionInfo.department ? admissionInfo.department.name : '', colSpan: 4 },
                            {}, {}, {}
                        ],
                        [
                            { text: 'B. ', colSpan: 4 },
                            {}, {}, {},
                            { text: '', colSpan: 4 },
                            {}, {}, {}
                        ],
                        [
                            { text: 'General Examination/Vital Signs:', bold: true, colSpan: 8, background: '#e6e6e6' },
                            {}, {}, {}, {}, {}, {}, {}
                        ],
                        [
                            { text: 'GCS On Admission:', bold: true },
                            { text: phcGeneral.gcs || '' },
                            { text: 'SPO2:', bold: true },
                            { text: phcGeneral.oxygen_level || '' },
                            { text: 'RBS/FBS:', bold: true },
                            { text: '' },
                            { text: 'Weight:', bold: true },
                            { text: phcGeneral.weight || '' }
                        ],
                        [
                            { text: 'Pulse:', bold: true },
                            { text: phcGeneral.pulse || '' },
                            { text: 'Respiratory Rate:', bold: true },
                            { text: phcGeneral.respiratory_rate || '' },
                            { text: 'BP:', bold: true },
                            { text: (phcGeneral.blood_pressure_uppper && phcGeneral.blood_pressure_lower) ? `${phcGeneral.blood_pressure_uppper}/${phcGeneral.blood_pressure_lower}` : '' },
                            { text: 'Temperature:', bold: true },
                            { text: phcGeneral.temperature || '' }
                        ],
                        [
                            { text: 'Heart Sound :', bold: true },
                            { text: findNote('heart_sound') },
                            { text: 'Plantar:', bold: true },
                            { text: findNote('plantar') },
                            { text: 'Abdomen:', bold: true },
                            { text: findNote('abdomen'), colSpan: 3 },
                            {},
                            {}
                        ],
                        [
                            { text: 'Chief Complaints:', bold: true, colSpan: 8, background: '#f2f2f2' },
                            {}, {}, {}, {}, {}, {}, {}
                        ],
                        [
                            { text: findNote('chief_complaints'), colSpan: 8 },
                            {}, {}, {}, {}, {}, {}, {}
                        ],
                        [
                            { text: 'Diagnosis on Admission:', bold: true, colSpan: 8, background: '#f2f2f2' },
                            {}, {}, {}, {}, {}, {}, {}
                        ],
                        [
                            { text: findNote('diagnosis'), colSpan: 8 },
                            {}, {}, {}, {}, {}, {}, {}
                        ],
                        [
                            { text: "Investigation's:", bold: true, colSpan: 8, background: '#f2f2f2' },
                            {}, {}, {}, {}, {}, {}, {}
                        ],
                        [
                            { text: findNote('investigation_history'), colSpan: 8 },
                            {}, {}, {}, {}, {}, {}, {}
                        ],
                        [
                            { text: 'P. T. O', alignment: 'center', colSpan: 8, background: '#cccccc' },
                            {}, {}, {}, {}, {}, {}, {}
                        ]
                    ],
                    heights: [
                        'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 
                        'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 50, 'auto', 
                        50, 'auto', 50, 'auto'
                    ]
                },
                layout: {
                    hLineWidth: (i, node) => 1,
                    vLineWidth: (i, node) => 1,
                    hLineColor: (i, node) => '#999999',
                    vLineColor: (i, node) => '#999999'
                }
            },

            // Page 2
            { text: '', pageBreak: 'before' },
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            { text: 'Operation Note:', bold: true, background: '#f2f2f2' }
                        ],
                        [
                            { text: findNote('operation_note') }
                        ],
                        [
                            { text: 'Anesthesia Note:', bold: true, background: '#f2f2f2' }
                        ],
                        [
                            { text: findNote('anesthesia_note') }
                        ]
                    ],
                    heights: ['auto', 80, 'auto', 80]
                },
                layout: {
                    hLineWidth: (i, node) => 1,
                    vLineWidth: (i, node) => 1,
                    hLineColor: (i, node) => '#999999',
                    vLineColor: (i, node) => '#999999'
                },
                margin: [0, 10]
            },
            {
                table: {
                    widths: ['33%', '33%', '34%'],
                    body: [
                        [
                            { text: 'Appearance: ' + findNote('appearance') },
                            { text: 'Anemia : ' + findNote('anemia') },
                            { text: 'Cyanosis : ' + findNote('cyanosis') }
                        ],
                        [
                            { text: 'Jaundice : ' + findNote('jaundice') },
                            { text: 'Edema : ' + findNote('edema') },
                            { text: 'Dehydration : ' + findNote('dehydration') }
                        ],
                        [
                            { text: 'Clubbing : ' + findNote('clubbing') },
                            { text: 'Skin : ' + findNote('skin') },
                            { text: 'Lymph Node : ' + findNote('lymph_node') }
                        ],
                        [
                            { text: 'Signs of M. Irritation : ' + findNote('signs_of_m_irritation') },
                            { text: 'Thyroid : ' + findNote('thyroid') },
                            { text: 'Blood Group : ' + convertToTitleCase(phcGeneral.blood_group) }
                        ],
                        [
                            { text: 'Bowel Sound : ' + findNote('bowel_sound') },
                            { text: 'Drug History : ' + findNote('drug_history'), colSpan: 2 },
                            {}
                        ]
                    ]
                },
                layout: {
                    hLineWidth: (i, node) => 1,
                    vLineWidth: (i, node) => 1,
                    hLineColor: (i, node) => '#999999',
                    vLineColor: (i, node) => '#999999'
                },
                margin: [0, 5]
            },
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            { text: 'History On Discharge: (Must be Filled)', bold: true, background: '#f2f2f2' }
                        ],
                        [
                            { text: findNote('history_on_discharge') }
                        ],
                        [
                            { text: 'General Note: (If Any)', bold: true, background: '#f2f2f2' }
                        ],
                        [
                            { text: findNote('general_note') }
                        ]
                    ],
                    heights: ['auto', 150, 'auto', 150]
                },
                layout: {
                    hLineWidth: (i, node) => 1,
                    vLineWidth: (i, node) => 1,
                    hLineColor: (i, node) => '#999999',
                    vLineColor: (i, node) => '#999999'
                },
                margin: [0, 5]
            },
            {
                margin: [0, 20, 0, 0],
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            { text: 'Signature of Hospital Authority', color: '#0066cc', fontSize: 8 },
                            { text: "Signature of Patient's Guardian", color: '#0066cc', fontSize: 8, alignment: 'right' }
                        ],
                        [
                            { text: '\n\n\n\n', minHeight: 40 },
                            { text: '\n\n\n\n', minHeight: 40 }
                        ],
                        [
                            { text: 'Signature, (Hospital Authority)', bold: true, background: '#e6e6e6' },
                            { text: "Signature, (Patient's Guardian)", bold: true, background: '#e6e6e6', alignment: 'right' }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: (i, node) => 1,
                    vLineWidth: (i, node) => 1,
                    hLineColor: (i, node) => '#999999',
                    vLineColor: (i, node) => '#999999'
                },
                margin: [0, 10]
            }
        ];
    }

    return {
        exportToStaticPDF
    }
}

export default ipdStaticAdmission;
